/* GST Payments API client — Phase 5 Bundle B
 *
 * UI shape: flat global list (not partitioned by month)
 *   gstPayments = [{ id, amount, note, createdAt }, ...]
 *
 * API shape: same flat list, with paidOn date for remittance date.
 * UI's `createdAt` is mapped from API's `paidOn` for backward compat.
 */
import { api } from "./api";

const BASE = "/gst-payments";

export function gstApiToUi(r) {
  return {
    id: r.id,
    amount: r.amount != null ? Number(r.amount) : 0,
    note: r.note || "",
    // The UI uses `createdAt` as the remittance date string.
    createdAt: r.paidOn ? String(r.paidOn).slice(0, 10)
                        : String(r.createdAt || "").slice(0, 10),
  };
}

export const gstApi = {
  async list() {
    const rows = await api.get(BASE);
    return (Array.isArray(rows) ? rows : []).map(gstApiToUi);
  },

  async create({ amount, note, createdAt }) {
    const payload = {
      amount: Number(amount) || 0,
      note: note || "",
    };
    if (createdAt) payload.paidOn = createdAt;
    const res = await api.post(BASE, payload);
    return gstApiToUi(res);
  },

  async update(id, patch) {
    const payload = {};
    if (patch.amount !== undefined) payload.amount = Number(patch.amount) || 0;
    if (patch.note !== undefined)   payload.note = patch.note;
    if (patch.createdAt)            payload.paidOn = patch.createdAt;
    const res = await api.patch(`${BASE}/${encodeURIComponent(id)}`, payload);
    return gstApiToUi(res);
  },

  async delete(id) {
    return api.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
